import React from 'react'
import { Link } from 'react-router-dom'
import { t } from 'ttag'

import {
  findBudgetAmountInRound,
  formatCurrency
} from '../../../actions/assessments/budget'

const BudgetFooterBar = ({
  currentRound,
  responses,
  county,
  rounds,
  forwardBudget,
  startingSalary,
  monthlyTotal,
  occupation
}) => {
  return (
    <div id="navbar" className="budget-forward">
      <div id="selectioninfocontainer">
        <Link id="county" to="/budget/county">
          <div className="withicons icon locationicon"></div>
          <div className="topname">
            <span>{t`Location`}</span>:
            <span id="countyvalue" className="selectedvalue">
              {' '}
              {county?.name}
            </span>
          </div>
        </Link>
        {!forwardBudget && occupation && (
          <a id="initialocc" className="reverse-only">
            <br className="clear reverse-only" />
            <div className="withicons icon occupationicon"></div>
            <div className="topname">
              <span>{t`Occupation`}</span>:
              <span id="initialoccvalue" className="selectedvalue">
                {occupation.title}
              </span>
            </div>
          </a>
        )}

        <br className="clear" />
      </div>
      <div id="selectioncontainer">
        {!forwardBudget && (
          <Link id="earnings" className={`section-container`} to="/budget/reverse">
            <div className="withicons icon earningsicon"></div>
            <div className="name">
              <span>{t`Salary`}</span>
            </div>
            <div id="earningsvalue" className="selectedvalue">
              {formatCurrency(startingSalary / 12)}
            </div>
          </Link>
        )}
        {!forwardBudget && <div className="quantification-total">-</div>}
        {rounds
          .filter(r => r.visibleMenu)
          .map((r, idx) => {
            const rndA = []

            if (idx > 0) {
              rndA.push(<div className="quantification">{forwardBudget ? '+' : '-'}</div>)
            }

            rndA.push(
              <Link
                to={`/budget/round/${r.roundId}`}
                id={r.id}
                className={`section-container ${
                  currentRound === r.roundId ? 'section-selected' : ''
                }`}>
                <div className={`withicons icon ${r.id}icon`}></div>
                <div className="name">
                  <span>{r.name()}</span>
                </div>
                <div className="selectedvalue" id={`${r.id}value`}>
                  {findBudgetAmountInRound(r.roundId, responses)}
                </div>
              </Link>
            )

            return rndA
          })}
        <div className="quantification-total">=</div>
        <Link
          id="total"
          className={`section-container ${monthlyTotal < 0 ? 'overspent' : ''}`}
          to="/budget/summary">
          <div className="withicons icon totalicon"></div>
          <div className="name">
            <span>{t`Total`}</span>
          </div>
          <div id="totalvalue" className="selectedvalue">
            {formatCurrency(monthlyTotal)}
          </div>
        </Link>
      </div>
      <br className="clear" />
    </div>
  )
}

export default BudgetFooterBar
